export default __webpack_public_path__ + "static/media/touch.8fc8865a.svg";